export { default } from './CurrencyDisplay';



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyDisplay/index.jsx